import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { loadTranslations } from '@angular/localize';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { LanguageService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class LanguageResolver {
  constructor(
    private languageService: LanguageService,
    private httpClient: HttpClient,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.languageService
      .getLanguage()
      .pipe(
        switchMap((language: string) =>
          this.httpClient
            .get(`assets/locale/messages.${language}.json`)
            .pipe(tap((translations: any) => loadTranslations(translations.translations))),
        ),
      );
  }
}
